import axios from "axios";

// Use same-origin API on Emergent-deployed apps (frontend and backend share the same host via /api ingress).
// Fallback to env var for local Node/SSR contexts where window is unavailable.
const BACKEND_URL =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach restaurant JWT if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vytali_rest_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
